import { render, staticRenderFns } from "./terminateServices.vue?vue&type=template&id=2fc24c5b"
import script from "./terminateServices.ts?vue&type=script&lang=js&external"
export * from "./terminateServices.ts?vue&type=script&lang=js&external"
import style0 from "./terminateServices.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports